// calanderList/actionTypes.js

const REQUEST_GAME_DATE_DATA = '@@calendar/REQUEST_GAME_DATE_DATA';
const GAME_DATE_DATA_RESPONSE = '@@calendar/GAME_DATE_DATA_RESPONSE';
const SET_EVENTS_BY_DATE = '@@calendarList/SET_EVENTS_BY_DATE';

export default {
    REQUEST_GAME_DATE_DATA,
    GAME_DATE_DATA_RESPONSE,
    SET_EVENTS_BY_DATE
}